import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "../../data/content";
import { SectionLabel } from "./Shared";

export default function Manifesto() {
  return (
    <section className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionLabel num="[ 02 ]">How We Operate</SectionLabel>
        <div className="mt-10 space-y-0">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="relative grid md:grid-cols-12 gap-6 md:gap-10 items-start py-10 md:py-14 border-t border-white/10"
              data-testid={`manifesto-${i}`}
            >
              <span
                className="pointer-events-none select-none absolute -top-6 -left-2 md:left-0 font-display font-black text-white/[0.04] leading-none text-[8rem] md:text-[15rem] -z-0"
              >
                {m.n}
              </span>
              <div className="md:col-span-4 relative z-10">
                <span className="mono-label text-cyan" style={{ color: "#00F0FF" }}>Chapter {m.n}</span>
                <h3 className="mt-4 font-display font-extrabold text-white tracking-tight text-3xl md:text-4xl leading-none">
                  {m.title}
                </h3>
              </div>
              <div className="md:col-span-8 relative z-10 md:pl-10">
                <p className="text-lg md:text-2xl leading-relaxed font-display font-light" style={{ color: "#94A3B8" }}>
                  {m.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
